const data = [
  { id: 1, name: 'SCREEN_OPEN' },
  { id: 2, name: 'CREDITOR_SELECTED' },
  { id: 3, name: 'PDF_DOWNLOADED' },
  { id: 4, name: 'CHECKBOX_ALL_CONFIRMED' },
  { id: 5, name: 'OPTION_SELECTED' },
  { id: 6, name: 'PDF_GENERATED' },
  { id: 7, name: 'PDF_UPLOADED' },
  { id: 8, name: 'PDF_UPLOAD_ERROR' },
  { id: 9, name: 'PROCESS_FINISHED' },
]

export const EVENT_TYPE = data.reduce((acc, item) => {
  acc[item.name] = item.id
  return acc
}, {})

export default [...data]
